import apinode from '../../apinode'

class TiposService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/tipos/${this.idconta}`)

    return response.data
  }
}

export default new TiposService()
